// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `:host ::ng-deep #residential-systems-area {
  padding: 4rem 0;
}
@media only screen and (min-width: 768px) and (max-width: 991px) {
  :host ::ng-deep #residential-systems-area {
    padding: 80px 10px;
  }
}
@media (max-width: 767px) {
  :host ::ng-deep #residential-systems-area {
    padding: 60px 10px;
  }
}

.header-eight {
  min-height: 100vh !important;
}
.header-eight .p-button {
  border-radius: 6px;
}
.header-eight .header-content .p-grid {
  margin-left: 0;
  margin-right: 0;
}
.header-eight .header-content .header-slogan-container {
  display: table;
  margin-bottom: 1.5rem;
}
.header-eight .header-content .header-slogan-container .header-slogan {
  display: table-cell;
  vertical-align: middle;
  text-align: center;
}
.header-eight .header-content .header-slogan-container .sub-heading-2 {
  display: none;
}
@media screen and (min-width: 768px) {
  .header-eight .header-content .header-slogan-container .sub-heading-2 {
    display: block;
  }
}

@media screen and (min-width: 768px) {
  .header-eight .header-content .header-slogan-container .sub-heading-2 {
    display: block;
  }
}
.build-form-wrapper,
.retail-form-wrapper,
.products-form-wrapper {
  background-color: var(--secondary);
  background-image: linear-gradient(to bottom right, var(--secondary), var(--secondary-light));
  border: 1px solid var(--secondary);
}

::ng-deep .five-option-select-button .p-button {
  width: 20% !important;
}

::ng-deep .two-option-select-button-wrapper .two-option-select-button .p-button {
  width: calc(50% - 10px) !important;
}

::ng-deep .four-option-select-button .p-button {
  width: 25% !important;
}

.build-form-wrapper,
.retail-form-wrapper,
.products-form-wrapper {
  padding: 10px 0 10px 10px;
}
.build-form-wrapper ::ng-deep #solar-choice .two-option-select-button .p-button,
.build-form-wrapper ::ng-deep #solar-assoc .two-option-select-button .p-button,
.build-form-wrapper ::ng-deep #solar-existing .two-option-select-button .p-button,
.retail-form-wrapper ::ng-deep #solar-choice .two-option-select-button .p-button,
.retail-form-wrapper ::ng-deep #solar-assoc .two-option-select-button .p-button,
.retail-form-wrapper ::ng-deep #solar-existing .two-option-select-button .p-button,
.products-form-wrapper ::ng-deep #solar-choice .two-option-select-button .p-button,
.products-form-wrapper ::ng-deep #solar-assoc .two-option-select-button .p-button,
.products-form-wrapper ::ng-deep #solar-existing .two-option-select-button .p-button {
  height: 62px !important;
  margin: 0 10px 8px 0;
  border: 1px solid var(--primary);
  color: var(--primary);
  border-radius: 5px;
}
.build-form-wrapper ::ng-deep #solar-choice .two-option-select-button .p-button.p-highlight,
.build-form-wrapper ::ng-deep #solar-assoc .two-option-select-button .p-button.p-highlight,
.build-form-wrapper ::ng-deep #solar-existing .two-option-select-button .p-button.p-highlight,
.retail-form-wrapper ::ng-deep #solar-choice .two-option-select-button .p-button.p-highlight,
.retail-form-wrapper ::ng-deep #solar-assoc .two-option-select-button .p-button.p-highlight,
.retail-form-wrapper ::ng-deep #solar-existing .two-option-select-button .p-button.p-highlight,
.products-form-wrapper ::ng-deep #solar-choice .two-option-select-button .p-button.p-highlight,
.products-form-wrapper ::ng-deep #solar-assoc .two-option-select-button .p-button.p-highlight,
.products-form-wrapper ::ng-deep #solar-existing .two-option-select-button .p-button.p-highlight {
  color: var(--secondary-light);
}
.build-form-wrapper ::ng-deep #solar-choice .two-option-select-button .p-button.p-highlight .p-button-icon,
.build-form-wrapper ::ng-deep #solar-assoc .two-option-select-button .p-button.p-highlight .p-button-icon,
.build-form-wrapper ::ng-deep #solar-existing .two-option-select-button .p-button.p-highlight .p-button-icon,
.retail-form-wrapper ::ng-deep #solar-choice .two-option-select-button .p-button.p-highlight .p-button-icon,
.retail-form-wrapper ::ng-deep #solar-assoc .two-option-select-button .p-button.p-highlight .p-button-icon,
.retail-form-wrapper ::ng-deep #solar-existing .two-option-select-button .p-button.p-highlight .p-button-icon,
.products-form-wrapper ::ng-deep #solar-choice .two-option-select-button .p-button.p-highlight .p-button-icon,
.products-form-wrapper ::ng-deep #solar-assoc .two-option-select-button .p-button.p-highlight .p-button-icon,
.products-form-wrapper ::ng-deep #solar-existing .two-option-select-button .p-button.p-highlight .p-button-icon {
  color: var(--secondary-light);
}
.build-form-wrapper ::ng-deep #solar-choice .two-option-select-button .p-button .p-button-icon,
.build-form-wrapper ::ng-deep #solar-assoc .two-option-select-button .p-button .p-button-icon,
.build-form-wrapper ::ng-deep #solar-existing .two-option-select-button .p-button .p-button-icon,
.retail-form-wrapper ::ng-deep #solar-choice .two-option-select-button .p-button .p-button-icon,
.retail-form-wrapper ::ng-deep #solar-assoc .two-option-select-button .p-button .p-button-icon,
.retail-form-wrapper ::ng-deep #solar-existing .two-option-select-button .p-button .p-button-icon,
.products-form-wrapper ::ng-deep #solar-choice .two-option-select-button .p-button .p-button-icon,
.products-form-wrapper ::ng-deep #solar-assoc .two-option-select-button .p-button .p-button-icon,
.products-form-wrapper ::ng-deep #solar-existing .two-option-select-button .p-button .p-button-icon {
  font-size: 1.25rem;
  color: var(--primary-dark);
}
.build-form-wrapper ::ng-deep #solar-choice .two-option-select-button .p-button .p-button-label,
.build-form-wrapper ::ng-deep #solar-assoc .two-option-select-button .p-button .p-button-label,
.build-form-wrapper ::ng-deep #solar-existing .two-option-select-button .p-button .p-button-label,
.retail-form-wrapper ::ng-deep #solar-choice .two-option-select-button .p-button .p-button-label,
.retail-form-wrapper ::ng-deep #solar-assoc .two-option-select-button .p-button .p-button-label,
.retail-form-wrapper ::ng-deep #solar-existing .two-option-select-button .p-button .p-button-label,
.products-form-wrapper ::ng-deep #solar-choice .two-option-select-button .p-button .p-button-label,
.products-form-wrapper ::ng-deep #solar-assoc .two-option-select-button .p-button .p-button-label,
.products-form-wrapper ::ng-deep #solar-existing .two-option-select-button .p-button .p-button-label {
  font-size: 14px !important;
}
.build-form-wrapper .p-grid .p-field,
.retail-form-wrapper .p-grid .p-field,
.products-form-wrapper .p-grid .p-field {
  margin-right: 0;
  margin-bottom: 0.25rem;
}
@media screen and (min-width: 576px) {
  .build-form-wrapper,
  .retail-form-wrapper,
  .products-form-wrapper {
    padding: 20px 16px 20px 20px;
  }
  .build-form-wrapper ::ng-deep #solar-choice .two-option-select-button .p-button .p-button-label,
  .build-form-wrapper ::ng-deep #solar-assoc .two-option-select-button .p-button .p-button-label,
  .build-form-wrapper ::ng-deep #solar-existing .two-option-select-button .p-button .p-button-label,
  .retail-form-wrapper ::ng-deep #solar-choice .two-option-select-button .p-button .p-button-label,
  .retail-form-wrapper ::ng-deep #solar-assoc .two-option-select-button .p-button .p-button-label,
  .retail-form-wrapper ::ng-deep #solar-existing .two-option-select-button .p-button .p-button-label,
  .products-form-wrapper ::ng-deep #solar-choice .two-option-select-button .p-button .p-button-label,
  .products-form-wrapper ::ng-deep #solar-assoc .two-option-select-button .p-button .p-button-label,
  .products-form-wrapper ::ng-deep #solar-existing .two-option-select-button .p-button .p-button-label {
    font-size: 16px !important;
  }
}
@media screen and (min-width: 768px) {
  .build-form-wrapper,
  .retail-form-wrapper,
  .products-form-wrapper {
    padding: 30px 24px 30px 30px;
  }
}
@media screen and (min-width: 992px) {
  .build-form-wrapper,
  .retail-form-wrapper,
  .products-form-wrapper {
    padding: 30px 20px 20px 30px;
  }
}
@media screen and (min-width: 1200px) {
  .build-form-wrapper,
  .retail-form-wrapper,
  .products-form-wrapper {
    padding: 30px 20px 20px 30px;
    margin: 0 50px;
  }
  .build-form-wrapper ::ng-deep #solar-choice .two-option-select-button .p-button,
  .build-form-wrapper ::ng-deep #solar-assoc .two-option-select-button .p-button,
  .build-form-wrapper ::ng-deep #solar-existing .two-option-select-button .p-button,
  .retail-form-wrapper ::ng-deep #solar-choice .two-option-select-button .p-button,
  .retail-form-wrapper ::ng-deep #solar-assoc .two-option-select-button .p-button,
  .retail-form-wrapper ::ng-deep #solar-existing .two-option-select-button .p-button,
  .products-form-wrapper ::ng-deep #solar-choice .two-option-select-button .p-button,
  .products-form-wrapper ::ng-deep #solar-assoc .two-option-select-button .p-button,
  .products-form-wrapper ::ng-deep #solar-existing .two-option-select-button .p-button {
    height: 82px !important;
    margin: 0 10px 8px 0;
    border: 1px solid var(--primary);
    color: var(--primary);
    border-radius: 5px;
  }
  .build-form-wrapper ::ng-deep #solar-choice .two-option-select-button .p-button .p-button-icon,
  .build-form-wrapper ::ng-deep #solar-assoc .two-option-select-button .p-button .p-button-icon,
  .build-form-wrapper ::ng-deep #solar-existing .two-option-select-button .p-button .p-button-icon,
  .retail-form-wrapper ::ng-deep #solar-choice .two-option-select-button .p-button .p-button-icon,
  .retail-form-wrapper ::ng-deep #solar-assoc .two-option-select-button .p-button .p-button-icon,
  .retail-form-wrapper ::ng-deep #solar-existing .two-option-select-button .p-button .p-button-icon,
  .products-form-wrapper ::ng-deep #solar-choice .two-option-select-button .p-button .p-button-icon,
  .products-form-wrapper ::ng-deep #solar-assoc .two-option-select-button .p-button .p-button-icon,
  .products-form-wrapper ::ng-deep #solar-existing .two-option-select-button .p-button .p-button-icon {
    font-size: 2em;
    color: var(--primary-dark);
  }
}`, "",{"version":3,"sources":["webpack://./src/app/home/home.component.scss"],"names":[],"mappings":"AACI;EACI,eAAA;AAAR;AAEI;EACI;IACI,kBAAA;EAAV;AACF;AAEI;EACI;IACI,kBAAA;EAAV;AACF;;AAIA;EACI,4BAAA;AADJ;AAEI;EACI,kBAAA;AAAR;AAGQ;EACI,cAAA;EACA,eAAA;AADZ;AAGQ;EACI,cAAA;EACA,qBAAA;AADZ;AAEY;EACI,mBAAA;EACA,sBAAA;EACA,kBAAA;AAAhB;AAEY;EACI,aAAA;AAAhB;AAEY;EACI;IACI,cAAA;EAAlB;AACF;;AAOA;EAIgB;IACI,cAAA;EAPlB;AACF;AAgBA;;;EAGI,kCAAA;EACA,4FAAA;EACA,kCAAA;AAdJ;;AAiBI;EACI,qBAAA;AAdR;;AAmBQ;EACI,kCAAA;AAhBZ;;AAsBI;EACI,qBAAA;AAnBR;;AAsBA;;;EAGI,yBAAA;AAnBJ;AAwBY;;;;;;;;;EACI,uBAAA;EACA,oBAAA;EACA,gCAAA;EACA,qBAAA;EACA,kBAAA;AAdhB;AAegB;;;;;;;;;EACI,6BAAA;AALpB;AAMoB;;;;;;;;;EACI,6BAAA;AAIxB;AADgB;;;;;;;;;EACI,kBAAA;EACA,0BAAA;AAWpB;AATgB;;;;;;;;;EACI,0BAAA;AAmBpB;AAbQ;;;EACI,eAAA;EACA,sBAAA;AAiBZ;AAdI;EApCJ;;;IAqCQ,4BAAA;EAmBN;EAbkB;;;;;;;;;IACI,0BAAA;EAuBtB;AACF;AAlBI;EAlDJ;;;IAmDQ,4BAAA;EAuBN;AACF;AAtBI;EArDJ;;;IAsDQ,4BAAA;EA2BN;AACF;AA1BI;EAxDJ;;;IAyDQ,4BAAA;IACA,cAAA;EA+BN;EAzBc;;;;;;;;;IACI,uBAAA;IACA,oBAAA;IACA,gCAAA;IACA,qBAAA;IACA,kBAAA;EAmClB;EAlCkB;;;;;;;;;IACI,cAAA;IACA,0BAAA;EA4CtB;AACF","sourcesContent":[":host ::ng-deep {\n    #residential-systems-area {\n        padding: 4rem 0;\n    }\n    @media only screen and (min-width: 768px) and (max-width: 991px) {\n        #residential-systems-area {\n            padding: 80px 10px;\n        }\n    }\n    @media (max-width: 767px) {\n        #residential-systems-area {\n            padding: 60px 10px;\n        }\n    }\n}\n\n.header-eight {\n    min-height: 100vh !important;\n    .p-button {\n        border-radius: 6px;\n    }\n    .header-content {\n        .p-grid {\n            margin-left: 0;\n            margin-right: 0;\n        }\n        .header-slogan-container {\n            display: table;\n            margin-bottom: 1.5rem;\n            .header-slogan {\n                display: table-cell;\n                vertical-align: middle;\n                text-align: center;\n            }\n            .sub-heading-2 {\n                display: none;\n            }\n            @media screen and (min-width: 768px) { // medium (md)\n                .sub-heading-2 {\n                    display: block;\n                }\n            }\n        }\n    }\n}\n@media screen and (min-width: 576px) {// small (sm)\n}\n@media screen and (min-width: 768px) {// medium (md)\n    .header-eight {\n        .header-content {\n            .header-slogan-container {\n                .sub-heading-2 {\n                    display: block;\n                }\n            }\n        }\n    }\n}\n@media screen and (min-width: 992px) {// large (lg)\n}\n@media screen and (min-width: 1200px) {// x-large (xl)\n}\n.build-form-wrapper,\n.retail-form-wrapper,\n.products-form-wrapper {\n    background-color: var(--secondary);\n    background-image: linear-gradient(to bottom right, var(--secondary), var(--secondary-light));\n    border: 1px solid var(--secondary);\n}\n::ng-deep .five-option-select-button {\n    .p-button {\n        width: 20% !important;\n    }\n}\n::ng-deep .two-option-select-button-wrapper {\n    .two-option-select-button {\n        .p-button {\n            width: calc(50% - 10px) !important;\n        }\n    }\n}\n\n::ng-deep .four-option-select-button {\n    .p-button {\n        width: 25% !important;\n    }\n}\n.build-form-wrapper,\n.retail-form-wrapper,\n.products-form-wrapper {\n    padding: 10px 0 10px 10px;\n    ::ng-deep #solar-choice,\n    ::ng-deep #solar-assoc,\n    ::ng-deep #solar-existing {\n        .two-option-select-button {\n            .p-button {\n                height: 62px !important;\n                margin: 0 10px 8px 0;\n                border: 1px solid var(--primary);\n                color: var(--primary);\n                border-radius: 5px;\n                &.p-highlight {\n                    color: var(--secondary-light);\n                    .p-button-icon {\n                        color: var(--secondary-light);\n                    }\n                }\n                .p-button-icon {\n                    font-size: 1.25rem;\n                    color: var(--primary-dark);\n                }\n                .p-button-label {\n                    font-size: 14px !important;\n                }\n            }\n        }\n    }\n    .p-grid {\n        .p-field {\n            margin-right: 0;\n            margin-bottom: 0.25rem;\n        }\n    }\n    @media screen and (min-width: 576px) {// small (sm)\n        padding: 20px 16px 20px 20px;\n        ::ng-deep #solar-choice,\n        ::ng-deep #solar-assoc,\n        ::ng-deep #solar-existing {\n            .two-option-select-button {\n                .p-button {\n                    .p-button-label {\n                        font-size: 16px !important;\n                    }\n                }\n            }\n        }\n    }\n    @media screen and (min-width: 768px) {// medium (md)\n        padding: 30px 24px 30px 30px;\n    }\n    @media screen and (min-width: 992px) {// large (lg)\n        padding: 30px 20px 20px 30px;\n    }\n    @media screen and (min-width: 1200px) {// x-large (xl)\n        padding: 30px 20px 20px 30px;\n        margin: 0 50px;\n\n        ::ng-deep #solar-choice,\n        ::ng-deep #solar-assoc,\n        ::ng-deep #solar-existing {\n            .two-option-select-button {\n                .p-button {\n                    height: 82px !important;\n                    margin: 0 10px 8px 0;\n                    border: 1px solid var(--primary);\n                    color: var(--primary);\n                    border-radius: 5px;\n                    .p-button-icon {\n                        font-size: 2em;\n                        color: var(--primary-dark);\n                    }\n                }\n            }\n        }\n    }\n}\n"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
